import React, { useState } from 'react'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'

import SEO from '@components/SEO'
import Layout from '@components/Layout'
import Section from '@components/Section'
import Heading from '@components/Heading'
import LayoutHeroMobile from '@components/Layout/Layout.Hero.Mobile'
import Image from '@components/Image'
import ScrollIndicator from '@components/ScrollIndicator'
import Pill from '@components/Pill'
import Transitions from '@components/Transitions'

import media from '@styles/media'
import { keyToSymbol } from '@shortcuts'

import LabsPreview from '../../sections/labs/Labs.Preview'
import LabsPreviewMobile from '../../sections/labs/Labs.Preview.Mobile'

/**
 * The labs page is a bit of a mess with the inlined Product Array but it
 * works for now. In the event that we redesign this page it's recommended
 * to start a new file to handle things neater!
 */

function LabsPage({ data, location }) {
  const {
    allContentfulPage,
    hero,
    heroBody,
    heroScreen,
    needlBackground,
    memoirBackground,
    feyBackground,
    novelaBackground,
    commandlineBackground,
  } = data
  const { seo } = allContentfulPage.edges[0].node
  const pageBackground =
    'linear-gradient(180deg, #08070B 40%, #111216 50%, #191D23 100%)'
  const navConfig = {
    fixed: true,
    theme: 'light',
    offset: true,
  }
  const footerConfig = {
    visible: true,
  }

  // Start the bulb up animation once the image has laoded
  const [showScreen, setShowScreen] = useState(false)

  // Inlining our products to get the right variables we need in scope!
  const products = [
    // {
    //   logo: NeedlLogo,
    //   background: needlBackground.childImageSharp.fluid,
    //   backgroundColor: '#060608',
    //   excerpt:
    //     "Whether you're looking to get inked or you're a tattoo artist yourself, this upcoming app will help you get what you need. Find artists and styles, schedule appointments, book flashes and get paid.",
    //   children: (
    //     <>
    //       <HorizontalRule dark />
    //       <LinkToProduct dark as="div">
    //         Coming: when it’s ready
    //       </LinkToProduct>
    //     </>
    //   ),
    // },
    // {
    //   logo: FeyLogo,
    //   background: feyBackground.childImageSharp.fluid,
    //   backgroundColor: '#16171C',
    //   excerpt:
    //     'Sick of tracking your trades across Evernote, Excel files and countless screenshots? Fey gives you the complete picture of your portfolio, with fast data entry, always-on risk analysis and more.',
    //   children: (
    //     <>
    //       <HorizontalRule />
    //       <div>
    //         <LinkToProduct
    //           target="_blank"
    //           data-a11y="false"
    //           href="https://feyapp.com"
    //         >
    //           <GlobeIcon aria-hidden="true" />
    //           Visit website
    //         </LinkToProduct>
    //         <LinkToProduct
    //           target="_blank"
    //           data-a11y="false"
    //           href="https://narative.co/design/open/fey"
    //         >
    //           <FigmaIcon aria-hidden="true" /> View in Figma
    //         </LinkToProduct>
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   logo: CommandlineLogo,
    //   background: commandlineBackground.childImageSharp.fluid,
    //   backgroundColor: '#222838',
    //   excerpt:
    //     'Computers have plenty of buttons, so we wondered: why explore the web with just one? Async Command lets you instantly access any page on Async.co with simple keyboard shortcuts.',
    //   children: (
    //     <>
    //       <HorizontalRule />
    //       <LinkToProduct dark as="div">
    //         Try it out! Just press <Symbol>{keyToSymbol('meta')}</Symbol>{' '}
    //         <Symbol>K</Symbol>
    //       </LinkToProduct>
    //     </>
    //   ),
    // },
    {
      logo: NovelaLogo,
      background: novelaBackground.childImageSharp.fluid,
      backgroundColor: '#a8cee8',
      excerpt:
        'Not only does Supply 19 provide its users with access to all confirmed leads in their area, but it also provides them with a place to ask questions and receive personalised responses from our moderators.',
      children: (
        <>
          <HorizontalRule dark />
          <div>
            <LinkToProduct
              target="_blank"
              data-a11y="false"
              href="https://supply19.in"
              style={{ color: '#08080B' }}
            >
              <GlobeIcon aria-hidden="true" fill="#08080B"/>
              Visit website
            </LinkToProduct>
          </div>
        </>
      ),
    },
    {
      logo: MemoirLogo,
      background: memoirBackground.childImageSharp.fluid,
      backgroundColor: '#D4D7DB',
      excerpt:
        'Faux, an  application in which we are working on a deep fake model thats different from existing applications on the market.In comparison to other applications on the market, this one is extremely distinctive.',
      children: (
        <>
          <HorizontalRule dark />
          <LinkToProduct dark as="div">
            Coming soon
          </LinkToProduct>
        </>
      ),
    },
  ].reverse()

  return (
    <Layout nav={navConfig} background={pageBackground} footer={footerConfig}>
      <>
        <SEO
          title={seo.title}
          description={seo.description}
          image={seo.image.file.url}
          pathname={location.pathname}
        />
        <LayoutHeroMobile>
          <HeroSection hideOverflow>
            <ContentContainer>
              <div />
              <Transitions.CSS.FadeIn>
                <TextContainer>
                  <Pill text="Labs" />
                  <Heading.h2 styles="h1">
                    Whether with our clients or all by ourselves, we’re always
                    busy building something new.
                  </Heading.h2>
                  <MainText>
                    Take a peek at the products we’re creating in-house at
                    Async.
                  </MainText>
                </TextContainer>
              </Transitions.CSS.FadeIn>
              <ScrollIndicator />
            </ContentContainer>

            <HeroImage>
              <Image
                onLoad={() => setShowScreen(true)}
                src={heroBody.childImageSharp.fluid}
              />
              <div
                style={{
                  opacity: showScreen ? 1 : 0,
                  transition: 'opacity 1s ease 0.5s',
                }}
              >
                <Image src={heroScreen.childImageSharp.fluid} />
              </div>
            </HeroImage>
          </HeroSection>
        </LayoutHeroMobile>
        <HeroImageMobile>
          <Image src={hero.childImageSharp.fluid} />
        </HeroImageMobile>
        <LabsBody>
          <Section narrow>
            {products.map(product => (
              <LabsPreview key={product.excerpt} product={product} />
            ))}
          </Section>
          <Section narrow>
            <LabsPreviewMobile />
          </Section>
        </LabsBody>
      </>
    </Layout>
  )
}

export default LabsPage

export const pageQuery = graphql`
  query LabsPageQuery {
    allContentfulPage(filter: { pageName: { eq: "Labs" } }) {
      edges {
        node {
          seo {
            title
            description
            image {
              file {
                url
              }
            }
          }
        }
      }
    }
    hero: file(name: { regex: "/labs-hero-phone/" }) {
      childImageSharp {
        fluid(maxWidth: 1060, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    heroBody: file(name: { regex: "/labs-floating-phone-body/" }) {
      childImageSharp {
        fluid(maxWidth: 1060, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    heroScreen: file(name: { regex: "/labs-floating-phone-screen/" }) {
      childImageSharp {
        fluid(maxWidth: 1060, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    needlBackground: file(name: { regex: "/labs-needl-desktop/" }) {
      childImageSharp {
        fluid(maxWidth: 793, maxHeight: 381, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    feyBackground: file(name: { regex: "/labs-fey-desktop/" }) {
      childImageSharp {
        fluid(maxWidth: 793, maxHeight: 381, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    commandlineBackground: file(name: { regex: "/labs-command-desktop/" }) {
      childImageSharp {
        fluid(maxWidth: 793, maxHeight: 381, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    novelaBackground: file(name: { regex: "/labs-novela-desktop/" }) {
      childImageSharp {
        fluid(maxWidth: 793, maxHeight: 381, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    memoirBackground: file(name: { regex: "/labs-memoir-desktop/" }) {
      childImageSharp {
        fluid(maxWidth: 793, maxHeight: 381, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`

const HeroSection = styled(Section)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media.tablet`
    pointer-events: none;
  `};
`

const HeroImage = styled.div`
  position: relative;
  width: 610px;
  top: -180px;
  right: -40px;
  animation: float 4.8s ease-in-out infinite 1.4s;

  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(-8px);
    }
    100% {
      transform: translatey(0px);
    }
  }

  ${media.tablet`
    display: none;
  `};

  .gatsby-image-wrapper {
    position: absolute !important;
    top: -180px;
    left: 0;
    width: 100%;
  }
`

const HeroImageMobile = styled(HeroImage)`
  display: none;

  ${media.tablet`
    box-shadow: 0px -40px 40px rgba(8, 7, 11, 0.8);
    display: block;
    width: 100%;
    top: 0;
    right: 0;
    margin-bottom: 60px;
  `};

  .gatsby-image-wrapper {
    position: relative !important;
    top: 0;
    left: 0;
    width: 100%;
  }
`

const TextContainer = styled.div`
  max-width: 560px;

  ${media.phablet`
    position: relative;
    top: -50px;
  `}
`

const MainText = styled.p`
  font-size: 3.2rem;
  font-weight: 400;
  color: ${p => p.theme.colors.grey};
  line-height: 1.3;

  ${media.phablet`
    font-size: 2.2rem;
  `};
`

const ContentContainer = styled.div`
  height: calc(100vh - 140px);
  min-height: 440px;

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${media.tablet`
    height: calc(100vh - 90px);
    padding: 0;
    user-select: none;
    pointer-events: none;
  `};
`

const HorizontalRule = styled.hr`
  width: 140px;
  height: 1px;
  border: none;
  margin-bottom: 30px;
  background: ${p => (p.dark ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255,255,255,0.1)')};

  ${media.phablet`
    width: 100%;
    margin: 0 auto 25px;
    background: ${p =>
      p.dark ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255,255,255,0.1)'};
  `}
`

const LabsBody = styled.div`
  position: relative;
  z-index: 1;
`

const LinkToProduct = styled.a`
  position: relative;
  font-weight: 600;
  font-size: 16px;
  color: ${p => (p.dark ? p.theme.colors.grey : '#fff')};

  svg {
    margin-right: 13px;
  }

  &:nth-child(2) {
    margin-left: 30px;
  }

  &[data-a11y='true']:focus::after {
    content: '';
    position: absolute;
    left: -10%;
    top: -42%;
    width: 120%;
    height: 200%;
    border: 2px solid ${p => p.theme.colors.purple};
    background: rgba(255, 255, 255, 0.01);
    border-radius: 5px;
  }

  ${media.tablet`
    display: block;
    margin: 0 auto;
    color: ${p => (p.dark ? '#000' : '#fff')};

    &:nth-child(2) {
      margin: 15px auto 0;
    }

      svg {
        display: none;
      }
  `}
`

const Symbol = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  min-width: 16px;
  text-align: center;
  border-radius: 2.5px;
  padding: 1px 2px;
  color: ${p => p.theme.colors.bg};
  background: ${p => p.theme.colors.moon};
  font-size: 12px;
  font-weight: 400;
  margin-left: 5px;
`

const NeedlLogo = () => (
  <svg
    width="141"
    height="21"
    viewBox="0 0 141 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.56191 10.7528H7.55691C11.5889 10.7528 12.7439 8.52681 12.7439 6.21681C12.7439 3.17181 10.8329 1.76481 7.51491 1.76481H0.836914V2.77281C1.92891 2.79381 2.26491 3.08781 2.26491 4.28481V13.9028C2.26491 15.0998 1.92891 15.3938 0.836914 15.3938V16.3598H7.34691V15.3938C5.91891 15.3938 5.56191 15.0788 5.56191 13.8818V10.7528ZM9.23691 6.25881C9.23691 8.52681 8.62791 9.19881 6.96891 9.19881H5.56191V3.25581H6.80091C8.62791 3.25581 9.23691 4.05381 9.23691 6.25881Z"
      fill="#FAFAFA"
    />
    <path
      d="M18.39 8.08581C18.348 6.69981 17.886 5.67081 17.739 5.39781H17.424L14.043 6.23781V7.16181C15.093 7.20381 15.303 7.41381 15.303 8.94681V13.9448C15.303 15.1418 15.072 15.3938 14.022 15.4148V16.3598H20.091V15.4148C18.663 15.3938 18.432 15.1418 18.432 13.9448V10.6688C18.432 9.03081 18.852 8.52681 20.448 8.52681C20.952 8.52681 21.225 8.58981 21.603 8.69481L22.191 5.52381C22.023 5.46081 21.729 5.39781 21.414 5.39781C20.259 5.39781 18.915 6.27981 18.39 8.08581Z"
      fill="#FAFAFA"
    />
    <path
      d="M33.4307 10.8578C33.4307 7.18281 31.2467 5.39781 28.2017 5.39781C24.8627 5.39781 22.7627 7.64481 22.7627 11.0468C22.7627 14.5748 24.7367 16.6328 28.0337 16.6328C30.9527 16.6328 33.4307 14.8478 33.4307 10.8578ZM30.0077 10.7738C30.0077 14.0078 29.3777 15.3308 28.1387 15.3308C26.6267 15.3308 26.1857 14.0288 26.1857 11.0888C26.1857 7.77081 26.7737 6.74181 28.0967 6.74181C29.3567 6.74181 30.0077 7.72881 30.0077 10.7738Z"
      fill="#FAFAFA"
    />
    <path
      d="M35.9743 16.0238C35.9743 18.1868 35.5753 19.1738 34.2943 19.7618L34.9033 20.6858C36.8353 20.2238 39.0823 19.1528 39.0823 16.0238V5.50281H38.6203L34.6933 6.23781V7.16181C35.7433 7.20381 35.9743 7.41381 35.9743 8.94681V16.0238ZM39.2713 2.70981C39.2713 1.70181 38.4733 0.882812 37.4443 0.882812C36.3943 0.882812 35.5333 1.70181 35.5333 2.70981C35.5333 3.73881 36.3733 4.55781 37.3813 4.55781C38.4313 4.55781 39.2713 3.73881 39.2713 2.70981Z"
      fill="#FAFAFA"
    />
    <path
      d="M47.0471 14.8058C45.0311 14.8058 44.2331 13.8398 44.1491 11.4668H50.5331V10.5638C50.5331 7.35081 49.1891 5.39781 45.8921 5.39781C42.8471 5.39781 40.7891 7.43481 40.7891 10.9838C40.7891 14.5538 42.7001 16.6118 45.9551 16.6118C47.8241 16.6118 49.2101 16.0448 50.3441 14.9318L49.8401 14.0708C48.9371 14.5538 47.9291 14.8058 47.0471 14.8058ZM45.9131 6.69981C47.0051 6.69981 47.4251 7.49781 47.4251 10.0388H44.1701C44.3171 7.47681 44.8421 6.69981 45.9131 6.69981Z"
      fill="#FAFAFA"
    />
    <path
      d="M60.7453 6.25881C60.0103 5.77581 58.9603 5.41881 57.3013 5.41881C54.3823 5.41881 51.9043 7.41381 51.9043 11.1938C51.9043 14.8688 54.2143 16.6118 57.0283 16.6118C58.6243 16.6118 60.0523 16.0448 61.0183 14.9108L60.4513 14.1128C59.5693 14.6378 58.9603 14.8688 57.9733 14.8688C56.3983 14.8688 55.1383 13.8608 55.1383 10.7108C55.1383 7.49781 56.3143 6.72081 57.3013 6.72081C58.1623 6.72081 58.3303 7.26681 58.4143 8.56881H60.7453V6.25881Z"
      fill="#FAFAFA"
    />
    <path
      d="M68.8113 5.67081H66.2703C66.2703 4.59981 66.3543 3.33981 66.4593 2.58381L64.2753 2.85681C63.7503 3.65481 63.4353 4.68381 63.3093 5.62881L61.9023 6.19581V7.26681H63.1623V13.6088C63.1623 15.9188 64.2333 16.6328 66.1443 16.6328C67.2993 16.6328 68.2023 16.3808 69.0003 15.8768L68.6853 14.7848C68.2023 14.9738 67.8663 15.0368 67.4883 15.0368C66.4383 15.0368 66.2913 14.4698 66.2913 12.9158V7.26681H68.4753L68.8113 5.67081Z"
      fill="#FAFAFA"
    />
    <path
      d="M85.0445 8.35881C85.0445 9.57681 85.1705 11.0048 85.2335 11.4878H85.1285C84.8975 10.8788 84.3935 9.78681 83.7425 8.75781L79.2905 1.76481H74.4395V2.77281C75.5315 2.79381 75.8675 3.08781 75.8675 4.28481V13.9028C75.8675 15.0998 75.5315 15.3938 74.4395 15.3938V16.3598H79.1225V15.3938C78.0095 15.3938 77.6735 15.0998 77.6735 13.9028V8.46381C77.6735 7.11981 77.5475 5.73381 77.4845 5.25081H77.5685C77.7785 5.71281 78.3245 6.84681 79.3115 8.37981L84.4565 16.3598H86.8084V4.28481C86.8084 3.08781 87.1235 2.79381 88.2155 2.77281V1.76481H83.5955V2.77281C84.7085 2.79381 85.0445 3.08781 85.0445 4.28481V8.35881Z"
      fill="#FAFAFA"
    />
    <path
      d="M95.507 14.8058C93.491 14.8058 92.693 13.8398 92.609 11.4668H98.993V10.5638C98.993 7.35081 97.649 5.39781 94.352 5.39781C91.307 5.39781 89.249 7.43481 89.249 10.9838C89.249 14.5538 91.16 16.6118 94.415 16.6118C96.284 16.6118 97.67 16.0448 98.804 14.9318L98.3 14.0708C97.397 14.5538 96.3891 14.8058 95.507 14.8058ZM94.373 6.69981C95.465 6.69981 95.885 7.49781 95.885 10.0388H92.63C92.777 7.47681 93.302 6.69981 94.373 6.69981Z"
      fill="#FAFAFA"
    />
    <path
      d="M106.622 14.8058C104.606 14.8058 103.808 13.8398 103.724 11.4668H110.108V10.5638C110.108 7.35081 108.764 5.39781 105.467 5.39781C102.422 5.39781 100.364 7.43481 100.364 10.9838C100.364 14.5538 102.275 16.6118 105.53 16.6118C107.399 16.6118 108.785 16.0448 109.919 14.9318L109.415 14.0708C108.512 14.5538 107.504 14.8058 106.622 14.8058ZM105.488 6.69981C106.58 6.69981 107 7.49781 107 10.0388H103.745C103.892 7.47681 104.417 6.69981 105.488 6.69981Z"
      fill="#FAFAFA"
    />
    <path
      d="M118.956 14.9318C119.019 15.8138 119.376 16.4648 119.523 16.6328H119.838L123.24 15.8768V15.0158C122.127 14.9318 121.896 14.7638 121.896 13.2308V0.945813H121.35L117.444 1.51281V2.43681C118.473 2.47881 118.788 2.68881 118.788 4.22181V6.44781C118.263 5.79681 117.339 5.41881 116.289 5.41881C113.538 5.41881 111.48 7.14081 111.48 11.0888C111.48 14.9318 113.244 16.6118 115.701 16.6118C117.129 16.6118 118.368 15.9188 118.956 14.9318ZM114.882 10.8578C114.882 7.91781 115.722 7.18281 116.982 7.18281C117.654 7.18281 118.305 7.39281 118.788 7.95981V13.7978C118.2 14.3858 117.549 14.6798 116.856 14.6798C115.596 14.6798 114.882 13.8188 114.882 10.8578Z"
      fill="#FAFAFA"
    />
    <path
      d="M128.433 3.02481C128.433 1.76481 128.16 1.15581 128.055 0.945813H127.74L123.939 1.51281V2.43681C125.01 2.47881 125.325 2.68881 125.325 4.22181V13.9448C125.325 15.1418 125.094 15.3938 124.023 15.4148V16.3598H129.735V15.4148C128.643 15.3938 128.433 15.1208 128.433 13.9238V3.02481Z"
      fill="#FAFAFA"
    />
    <path
      d="M137.117 14.8058C135.101 14.8058 134.303 13.8398 134.219 11.4668H140.603V10.5638C140.603 7.35081 139.259 5.39781 135.962 5.39781C132.917 5.39781 130.859 7.43481 130.859 10.9838C130.859 14.5538 132.77 16.6118 136.025 16.6118C137.894 16.6118 139.28 16.0448 140.414 14.9318L139.91 14.0708C139.007 14.5538 137.999 14.8058 137.117 14.8058ZM135.983 6.69981C137.075 6.69981 137.495 7.49781 137.495 10.0388H134.24C134.387 7.47681 134.912 6.69981 135.983 6.69981Z"
      fill="#FAFAFA"
    />
  </svg>
)

const FeyLogo = () => (
  <svg
    width="69"
    height="26"
    viewBox="0 0 69 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Fey Logo</title>
    <path
      d="M59.8015 15.4941L54 6H58.1844L61.5 12.2293L64.8384 6H69L63.2017 15.4941V20.8128C63.2009 21.1274 63.0799 21.4289 62.8653 21.6513C62.6507 21.8737 62.3599 21.9991 62.0564 22H59.8015V15.4941Z"
      fill="white"
    />
    <path
      d="M41.161 6.00002H51V8.06922C51 8.38434 50.8784 8.68656 50.6619 8.90939C50.4454 9.13222 50.1517 9.2574 49.8456 9.2574H43.4338V12.2414H48.6157V14.3106C48.6148 14.6254 48.4929 14.9271 48.2766 15.1497C48.0603 15.3724 47.7672 15.4979 47.4612 15.4987H43.4338V18.746H50.9934V20.8118C50.9939 20.968 50.9643 21.1227 50.9064 21.267C50.8486 21.4114 50.7636 21.5426 50.6563 21.653C50.549 21.7634 50.4216 21.8509 50.2813 21.9105C50.141 21.97 49.9907 22.0004 49.839 22H40V7.1882C40 7.0316 40.0301 6.87654 40.0885 6.73194C40.1469 6.58734 40.2325 6.45606 40.3404 6.34563C40.4483 6.23521 40.5764 6.14783 40.7172 6.08852C40.858 6.02921 41.0088 5.99913 41.161 6.00002Z"
      fill="white"
    />
    <path
      d="M28.2742 22H26V7.18744C26 6.87251 26.1217 6.57048 26.3383 6.34779C26.555 6.1251 26.8488 6 27.1551 6H37V8.06789C36.9991 8.38254 36.8772 8.68406 36.6607 8.90655C36.4443 9.12904 36.151 9.25443 35.8449 9.25532H29.4195V12.2374H34.634V14.3053C34.634 14.6202 34.5122 14.9222 34.2956 15.1449C34.079 15.3676 33.7852 15.4927 33.4788 15.4927H29.4195V20.8159C29.4195 21.1288 29.299 21.429 29.0844 21.6508C28.8698 21.8727 28.5785 21.9982 28.2742 22Z"
      fill="white"
    />
    <path
      d="M12.3557 21.3519C12.5597 21.5565 12.7218 21.8006 12.8324 22.0701C12.943 22.3395 13 22.6289 13 22.9211C13 23.2134 12.943 23.5028 12.8324 23.7722C12.7218 24.0417 12.5597 24.2858 12.3557 24.4904L10.8777 26L9.37507 24.459C8.55033 23.6131 8.06222 22.4836 8.00555 21.29C7.94888 20.0964 8.3277 18.9238 9.06842 18L12.3557 21.3519Z"
      fill="white"
    />
    <path
      d="M12.3612 9.60037C12.7703 10.0148 13 10.5764 13 11.162C13 11.7476 12.7703 12.3093 12.3612 12.7237L8.53364 16.5955C7.98718 17.1448 7.55408 17.7985 7.25948 18.5186C6.96489 19.2386 6.81469 20.0108 6.8176 20.79C6.81853 21.1966 6.86021 21.602 6.942 22L5.43328 20.4319C4.51549 19.5021 4 18.2418 4 16.9279C4 15.6139 4.51549 14.3536 5.43328 13.4238L10.7983 8L12.3612 9.60037Z"
      fill="white"
    />
    <path
      d="M12.3504 1.6047C12.7663 2.02399 13 2.59237 13 3.18499C13 3.77761 12.7663 4.34599 12.3504 4.76528L4.63302 12.5447C3.93442 13.247 3.42076 14.1137 3.13851 15.0662C2.85626 16.0187 2.81432 17.0271 3.01649 18L1.45492 16.4246C0.993711 15.9611 0.627808 15.4106 0.378155 14.8046C0.128502 14.1986 0 13.549 0 12.8929C0 12.2369 0.128502 11.5873 0.378155 10.9813C0.627808 10.3753 0.993711 9.82477 1.45492 9.3613L10.7532 0L12.3504 1.6047Z"
      fill="white"
    />
  </svg>
)

const CommandlineLogo = () => (
  <svg
    width="267"
    height="19"
    viewBox="0 0 267 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8163 8.85552C12.8163 10.2475 12.9603 11.8795 13.0323 12.4315H12.9123C12.6483 11.7355 12.0723 10.4875 11.3283 9.31152L6.24029 1.31952H0.696289V2.47152C1.94429 2.49552 2.32829 2.83152 2.32829 4.19952V15.1915C2.32829 16.5595 1.94429 16.8955 0.696289 16.8955V17.9995H6.04829V16.8955C4.77629 16.8955 4.39229 16.5595 4.39229 15.1915V8.97552C4.39229 7.43952 4.24829 5.85552 4.17629 5.30352H4.27229C4.51229 5.83152 5.13629 7.12752 6.26429 8.87952L12.1443 17.9995H14.8323V4.19952C14.8323 2.83152 15.1923 2.49552 16.4403 2.47152V1.31952H11.1603V2.47152C12.4323 2.49552 12.8163 2.83152 12.8163 4.19952V8.85552Z"
      fill="#FAFAFA"
    />
    <path
      d="M28.0347 14.3995C28.0347 12.2155 28.1307 10.2235 28.1307 9.50352C28.1307 6.69552 26.2107 5.47152 23.4507 5.47152C21.5067 5.47152 19.5387 6.07152 18.2667 6.81552V9.26353H20.9067C21.0747 7.99152 21.4587 7.07952 22.8267 7.07952C24.0987 7.07952 24.5547 7.87152 24.5547 9.71952V10.8235C24.2427 10.7995 23.6907 10.7755 23.4027 10.7755C19.6347 10.7755 17.4987 11.9515 17.4987 14.7835C17.4987 17.2555 19.1787 18.3355 21.3147 18.3355C23.2107 18.3355 24.2427 17.3275 24.6507 16.4635C24.8427 17.4715 25.6347 18.1435 27.1227 18.1435C28.1787 18.1435 29.0667 17.8795 29.5707 17.5675V16.5355C28.2987 16.4875 28.0347 16.1995 28.0347 14.3995ZM24.5067 12.1675L24.4347 15.2155C24.0027 15.7675 23.2347 16.1035 22.6107 16.1035C21.6987 16.1035 21.1707 15.6955 21.1707 14.3275C21.1707 12.8635 22.0347 12.1675 23.6667 12.1675H24.5067Z"
      fill="#FAFAFA"
    />
    <path
      d="M35.4757 8.54352C35.4277 6.95952 34.8997 5.78352 34.7317 5.47152H34.3717L30.5077 6.43152V7.48752C31.7077 7.53552 31.9477 7.77552 31.9477 9.52752V15.2395C31.9477 16.6075 31.6837 16.8955 30.4837 16.9195V17.9995H37.4197V16.9195C35.7877 16.8955 35.5237 16.6075 35.5237 15.2395V11.4955C35.5237 9.62352 36.0037 9.04752 37.8277 9.04752C38.4037 9.04752 38.7157 9.11952 39.1477 9.23952L39.8197 5.61552C39.6277 5.54352 39.2917 5.47152 38.9317 5.47152C37.6117 5.47152 36.0757 6.47952 35.4757 8.54352Z"
      fill="#FAFAFA"
    />
    <path
      d="M51.1207 14.3995C51.1207 12.2155 51.2167 10.2235 51.2167 9.50352C51.2167 6.69552 49.2967 5.47152 46.5367 5.47152C44.5927 5.47152 42.6247 6.07152 41.3527 6.81552V9.26353H43.9927C44.1607 7.99152 44.5447 7.07952 45.9127 7.07952C47.1847 7.07952 47.6407 7.87152 47.6407 9.71952V10.8235C47.3287 10.7995 46.7767 10.7755 46.4887 10.7755C42.7207 10.7755 40.5847 11.9515 40.5847 14.7835C40.5847 17.2555 42.2647 18.3355 44.4007 18.3355C46.2967 18.3355 47.3287 17.3275 47.7367 16.4635C47.9287 17.4715 48.7207 18.1435 50.2087 18.1435C51.2647 18.1435 52.1527 17.8795 52.6567 17.5675V16.5355C51.3847 16.4875 51.1207 16.1995 51.1207 14.3995ZM47.5927 12.1675L47.5207 15.2155C47.0887 15.7675 46.3207 16.1035 45.6967 16.1035C44.7847 16.1035 44.2567 15.6955 44.2567 14.3275C44.2567 12.8635 45.1207 12.1675 46.7527 12.1675H47.5927Z"
      fill="#FAFAFA"
    />
    <path
      d="M61.2016 5.78352H58.2976C58.2976 4.55953 58.3936 3.11952 58.5136 2.25552L56.0176 2.56752C55.4176 3.47952 55.0576 4.65552 54.9136 5.73552L53.3056 6.38352V7.60752H54.7456V14.8555C54.7456 17.4955 55.9696 18.3115 58.1536 18.3115C59.4736 18.3115 60.5056 18.0235 61.4176 17.4475L61.0576 16.1995C60.5056 16.4155 60.1216 16.4875 59.6896 16.4875C58.4896 16.4875 58.3216 15.8395 58.3216 14.0635V7.60752H60.8176L61.2016 5.78352Z"
      fill="#FAFAFA"
    />
    <path
      d="M68.6752 17.9995V16.9195C67.4272 16.8955 67.2112 16.6075 67.2112 15.2395V5.59152H66.6832L62.1952 6.43152V7.48752C63.3952 7.53552 63.6352 7.77552 63.6352 9.52752V15.2395C63.6352 16.6075 63.3712 16.8955 62.1712 16.9195V17.9995H68.6752ZM67.4032 2.39952C67.4032 1.24752 66.4912 0.311523 65.3152 0.311523C64.1152 0.311523 63.1552 1.24752 63.1552 2.39952C63.1552 3.57552 64.1152 4.51152 65.2672 4.51152C66.4672 4.51152 67.4032 3.57552 67.4032 2.39952Z"
      fill="#FAFAFA"
    />
    <path
      d="M76.4309 18.1195L79.9589 8.37552C80.3909 7.22352 80.6789 7.00752 81.6389 6.88752V5.78352H76.6229V6.88752C77.6069 6.91152 78.0389 7.15152 78.0389 7.72752C78.0389 7.87152 77.9909 8.06352 77.9189 8.30352L76.3829 13.0315C76.1429 13.8235 75.9269 14.6875 75.9029 14.8795H75.7589C75.7109 14.5195 75.5669 13.8235 75.3029 13.0315L73.6709 8.30352C73.5749 8.06352 73.5269 7.87152 73.5269 7.70352C73.5269 7.19952 73.8869 6.91152 74.8949 6.88752V5.78352H68.3909V6.88752C69.2309 7.00752 69.4709 7.22352 69.9269 8.37552L73.6709 18.1195H76.4309Z"
      fill="#FAFAFA"
    />
    <path
      d="M89.0157 16.2235C86.7117 16.2235 85.7997 15.1195 85.7037 12.4075H92.9997V11.3755C92.9997 7.70352 91.4637 5.47152 87.6957 5.47152C84.2157 5.47152 81.8637 7.79952 81.8637 11.8555C81.8637 15.9355 84.0477 18.2875 87.7677 18.2875C89.9037 18.2875 91.4877 17.6395 92.7837 16.3675L92.2077 15.3835C91.1757 15.9355 90.0237 16.2235 89.0157 16.2235ZM87.7197 6.95952C88.9677 6.95952 89.4477 7.87152 89.4477 10.7755H85.7277C85.8957 7.84752 86.4957 6.95952 87.7197 6.95952Z"
      fill="#FAFAFA"
    />
    <path
      d="M107.661 18.2875C110.061 18.2875 112.125 17.6875 113.109 16.9675V13.7995H110.637C110.325 15.7675 109.701 16.6555 107.805 16.6555C105.741 16.6555 104.301 15.5515 104.301 9.74352C104.301 4.27152 105.549 2.73552 107.805 2.73552C109.461 2.73552 110.013 3.67152 110.397 5.49552H112.989V2.23152C111.837 1.48752 110.205 1.03152 107.853 1.03152C103.245 1.03152 100.101 3.79152 100.101 9.88752C100.101 15.2875 102.765 18.2875 107.661 18.2875Z"
      fill="#FAFAFA"
    />
    <path
      d="M127.032 11.7115C127.032 7.51153 124.536 5.47152 121.056 5.47152C117.24 5.47152 114.84 8.03952 114.84 11.9275C114.84 15.9595 117.096 18.3115 120.864 18.3115C124.2 18.3115 127.032 16.2715 127.032 11.7115ZM123.12 11.6155C123.12 15.3115 122.4 16.8235 120.984 16.8235C119.256 16.8235 118.752 15.3355 118.752 11.9755C118.752 8.18353 119.424 7.00752 120.936 7.00752C122.376 7.00752 123.12 8.13552 123.12 11.6155Z"
      fill="#FAFAFA"
    />
    <path
      d="M140.475 7.60752C139.971 6.28752 138.771 5.49552 137.355 5.49552C135.627 5.49552 134.427 6.31152 133.395 7.55952C133.323 6.59952 132.891 5.75952 132.747 5.47152H132.387L128.523 6.43152V7.48752C129.723 7.53552 129.963 7.77552 129.963 9.52752V15.2395C129.963 16.6075 129.699 16.8955 128.499 16.9195V17.9995H134.883V16.9195C133.659 16.9195 133.539 16.6075 133.539 15.3115V8.87952C134.163 8.44752 134.811 8.01552 135.771 8.01552C136.683 8.01552 137.211 8.51952 137.211 9.95952V15.3115C137.211 16.6075 137.067 16.9195 135.867 16.9195V17.9995H142.083V16.9195C140.955 16.8955 140.787 16.6075 140.787 15.3115V8.80752C141.363 8.39952 142.011 8.01552 142.947 8.01552C143.859 8.01552 144.387 8.51952 144.387 9.95952V15.3115C144.387 16.6075 144.243 16.9195 143.043 16.9195V17.9995H149.379V16.9195C148.203 16.8955 147.939 16.6075 147.939 15.2395V9.11952C147.939 6.64752 146.451 5.49552 144.531 5.49552C142.827 5.49552 141.507 6.33552 140.475 7.60752Z"
      fill="#FAFAFA"
    />
    <path
      d="M162.342 7.60752C161.838 6.28752 160.638 5.49552 159.222 5.49552C157.494 5.49552 156.294 6.31152 155.262 7.55952C155.19 6.59952 154.758 5.75952 154.614 5.47152H154.254L150.39 6.43152V7.48752C151.59 7.53552 151.83 7.77552 151.83 9.52752V15.2395C151.83 16.6075 151.566 16.8955 150.366 16.9195V17.9995H156.75V16.9195C155.526 16.9195 155.406 16.6075 155.406 15.3115V8.87952C156.03 8.44752 156.678 8.01552 157.638 8.01552C158.55 8.01552 159.078 8.51952 159.078 9.95952V15.3115C159.078 16.6075 158.934 16.9195 157.734 16.9195V17.9995H163.95V16.9195C162.822 16.8955 162.654 16.6075 162.654 15.3115V8.80752C163.23 8.39952 163.878 8.01552 164.814 8.01552C165.726 8.01552 166.254 8.51952 166.254 9.95952V15.3115C166.254 16.6075 166.11 16.9195 164.91 16.9195V17.9995H171.246V16.9195C170.07 16.8955 169.806 16.6075 169.806 15.2395V9.11952C169.806 6.64752 168.318 5.49552 166.398 5.49552C164.694 5.49552 163.374 6.33552 162.342 7.60752Z"
      fill="#FAFAFA"
    />
    <path
      d="M182.746 14.3995C182.746 12.2155 182.842 10.2235 182.842 9.50352C182.842 6.69552 180.922 5.47152 178.162 5.47152C176.218 5.47152 174.25 6.07152 172.978 6.81552V9.26353H175.618C175.786 7.99152 176.17 7.07952 177.538 7.07952C178.81 7.07952 179.266 7.87152 179.266 9.71952V10.8235C178.954 10.7995 178.402 10.7755 178.114 10.7755C174.346 10.7755 172.21 11.9515 172.21 14.7835C172.21 17.2555 173.89 18.3355 176.026 18.3355C177.922 18.3355 178.954 17.3275 179.362 16.4635C179.554 17.4715 180.346 18.1435 181.834 18.1435C182.89 18.1435 183.778 17.8795 184.282 17.5675V16.5355C183.01 16.4875 182.746 16.1995 182.746 14.3995ZM179.218 12.1675L179.146 15.2155C178.714 15.7675 177.946 16.1035 177.322 16.1035C176.41 16.1035 175.882 15.6955 175.882 14.3275C175.882 12.8635 176.746 12.1675 178.378 12.1675H179.218Z"
      fill="#FAFAFA"
    />
    <path
      d="M197.795 9.11952C197.795 6.64752 196.283 5.49552 194.315 5.49552C192.443 5.49552 191.171 6.45552 190.139 7.63152C190.067 6.67152 189.611 5.73552 189.443 5.47152H189.083L185.219 6.43152V7.48752C186.419 7.53552 186.659 7.77552 186.659 9.52752V15.2395C186.659 16.6075 186.395 16.8955 185.195 16.9195V17.9995H191.699V16.9195C190.451 16.8955 190.235 16.5835 190.235 15.2875V8.92752C190.859 8.44752 191.579 8.01552 192.635 8.01552C193.643 8.01552 194.219 8.51952 194.219 9.95952V15.2875C194.219 16.5835 194.003 16.8955 192.779 16.9195V17.9995H199.211V16.9195C198.059 16.8955 197.795 16.6075 197.795 15.2395V9.11952Z"
      fill="#FAFAFA"
    />
    <path
      d="M208.955 16.3675C209.027 17.3755 209.435 18.1195 209.603 18.3115H209.963L213.851 17.4475V16.4635C212.579 16.3675 212.315 16.1755 212.315 14.4235V0.383524H211.691L207.227 1.03152V2.08752C208.403 2.13552 208.763 2.37552 208.763 4.12752V6.67152C208.163 5.92752 207.107 5.49552 205.907 5.49552C202.763 5.49552 200.411 7.46352 200.411 11.9755C200.411 16.3675 202.427 18.2875 205.235 18.2875C206.867 18.2875 208.283 17.4955 208.955 16.3675ZM204.299 11.7115C204.299 8.35153 205.259 7.51152 206.699 7.51152C207.467 7.51152 208.211 7.75152 208.763 8.39952V15.0715C208.091 15.7435 207.347 16.0795 206.555 16.0795C205.115 16.0795 204.299 15.0955 204.299 11.7115Z"
      fill="#FAFAFA"
    />
    <path
      d="M222.213 1H219V6.79266H222.213V5.81998H220.129V4.23938H222.126V3.26669H220.129V1.97268H222.213V1Z"
      fill="#E9DAAC"
    />
    <path
      d="M222.718 6.79266H224.073L225.41 4.67361L226.678 6.79266H228.033L226.053 3.73567L227.833 1H226.478L225.41 2.79772L224.394 1H223.039L224.767 3.73567L222.718 6.79266Z"
      fill="#E9DAAC"
    />
    <path
      d="M228.864 1V6.79266H229.993V4.64755H230.722C231.391 4.64755 231.868 4.45649 232.19 4.13516C232.633 3.69224 232.667 3.06695 232.667 2.84115C232.667 2.42428 232.546 1.85978 232.077 1.44292C231.651 1.06948 231.2 1 230.548 1H228.864ZM229.993 1.97268H230.383C230.653 1.97268 230.948 1.99005 231.182 2.15506C231.347 2.27664 231.504 2.49376 231.504 2.81509C231.504 3.06695 231.399 3.32749 231.191 3.4925C230.948 3.67487 230.67 3.67487 230.453 3.67487H229.993V1.97268Z"
      fill="#E9DAAC"
    />
    <path
      d="M236.716 1H233.503V6.79266H236.716V5.81998H234.632V4.23938H236.629V3.26669H234.632V1.97268H236.716V1Z"
      fill="#E9DAAC"
    />
    <path
      d="M237.811 1V6.79266H238.94V4.46518H239.079L240.625 6.79266H242.032L240.225 4.35228C240.503 4.30017 240.712 4.20464 240.859 4.10042C241.311 3.79646 241.537 3.30143 241.537 2.73693C241.537 2.3027 241.407 1.80767 240.964 1.43423C240.694 1.20843 240.286 1 239.487 1H237.811ZM238.94 1.92057H239.279C239.487 1.92057 240.373 1.92926 240.373 2.78904C240.373 3.64013 239.479 3.66619 239.261 3.66619H238.94V1.92057Z"
      fill="#E9DAAC"
    />
    <path d="M242.798 1V6.79266H243.927V1H242.798Z" fill="#E9DAAC" />
    <path
      d="M244.954 6.79266H246.1L246.691 3.22327L248.176 6.79266H248.558L250.112 3.22327L250.633 6.79266H251.78L250.807 1H249.991L248.384 4.68229L246.847 1H246.031L244.954 6.79266Z"
      fill="#E9DAAC"
    />
    <path
      d="M256.019 1H252.806V6.79266H256.019V5.81998H253.935V4.23938H255.932V3.26669H253.935V1.97268H256.019V1Z"
      fill="#E9DAAC"
    />
    <path
      d="M258.243 6.79266V2.91931L261.769 6.79266H262.551V1H261.422V4.86467L257.896 1H257.114V6.79266H258.243Z"
      fill="#E9DAAC"
    />
    <path
      d="M267 1.97268V1H263.266V1.97268H264.568V6.79266H265.697V1.97268H267Z"
      fill="#E9DAAC"
    />
  </svg>
)

const NovelaLogo = () => (
  <svg id="svg"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  width="200%"
  height="400%"
  viewBox="835, 170, 200, 250">
    
  <g id="svgg"><path id="path0" d="M208.800 199.600 L 208.800 225.600 216.000 225.600 L 223.200 225.600 223.200 199.600 L 223.200 173.600 216.000 173.600 L 208.800 173.600 208.800 199.600 M24.298 176.670 C 15.565 179.689,12.808 183.151,12.803 191.106 C 12.798 200.414,16.177 203.490,30.413 207.134 C 40.077 209.608,42.580 211.055,40.833 213.160 C 38.352 216.149,28.578 214.412,27.677 210.821 C 27.179 208.837,27.029 208.800,19.585 208.800 L 12.000 208.800 12.000 211.626 C 12.000 229.130,50.805 233.255,57.229 216.434 C 61.595 205.002,56.258 197.818,40.800 194.320 C 29.301 191.718,26.368 189.033,32.890 187.079 C 36.700 185.937,39.812 187.115,41.190 190.220 C 41.924 191.875,42.499 192.000,49.390 192.000 L 56.800 192.000 56.800 189.160 C 56.800 178.427,39.003 171.588,24.298 176.670 M358.395 175.903 C 338.543 182.384,342.078 207.959,362.831 207.992 C 366.057 207.997,368.680 207.481,370.727 206.437 L 373.793 204.874 373.274 208.237 C 371.930 216.954,360.000 219.160,360.000 210.692 C 360.000 209.855,358.413 209.600,353.200 209.600 C 345.732 209.600,345.831 209.513,347.295 214.800 C 351.371 229.514,377.980 231.395,385.250 217.482 C 390.311 207.796,388.771 186.415,382.598 180.639 C 377.737 176.092,365.282 173.654,358.395 175.903 M317.200 179.228 C 313.680 180.928,309.000 182.610,306.800 182.964 L 302.800 183.609 302.560 188.204 L 302.320 192.800 308.360 192.800 L 314.400 192.800 314.400 203.600 L 314.400 214.400 308.400 214.400 L 302.400 214.400 302.400 220.000 L 302.400 225.600 321.600 225.600 L 340.800 225.600 340.800 220.000 L 340.800 214.400 335.200 214.400 L 329.600 214.400 329.600 195.200 L 329.600 176.000 326.600 176.068 C 324.873 176.107,320.884 177.448,317.200 179.228 M371.141 187.537 C 373.375 189.915,373.584 194.608,371.556 196.849 C 369.340 199.298,363.776 198.985,361.658 196.292 C 356.546 189.793,365.497 181.529,371.141 187.537 M132.483 187.231 C 131.209 187.612,129.175 188.874,127.963 190.035 L 125.759 192.147 125.216 189.673 L 124.673 187.200 118.336 187.200 L 112.000 187.200 112.000 213.600 L 112.000 240.000 119.600 240.000 L 127.200 240.000 127.200 231.627 L 127.200 223.254 130.117 224.975 C 138.341 229.827,150.260 225.196,152.765 216.175 C 157.850 197.867,147.292 182.799,132.483 187.231 M180.633 187.191 C 179.441 187.550,177.421 188.588,176.143 189.498 C 173.672 191.257,172.800 191.040,172.800 188.667 C 172.800 187.367,172.073 187.200,166.400 187.200 L 160.000 187.200 160.000 213.600 L 160.000 240.000 167.600 240.000 L 175.200 240.000 175.200 232.000 C 175.200 224.811,175.810 222.551,177.160 224.735 C 180.410 229.994,195.720 225.991,199.351 218.933 C 207.870 202.372,196.159 182.511,180.633 187.191 M64.161 202.200 C 64.524 218.544,65.273 221.900,69.117 224.419 C 74.257 227.787,82.281 227.441,88.123 223.601 L 91.046 221.679 91.538 223.639 C 92.006 225.502,92.331 225.600,98.015 225.600 L 104.000 225.600 104.000 206.400 L 104.000 187.200 96.800 187.200 L 89.600 187.200 89.600 199.092 C 89.600 212.553,88.678 215.200,83.987 215.200 C 79.825 215.200,79.200 213.142,79.200 199.422 L 79.200 187.200 71.514 187.200 L 63.827 187.200 64.161 202.200 M227.416 188.171 C 227.642 188.737,231.170 197.567,235.258 207.794 L 242.690 226.388 240.806 228.394 C 239.251 230.048,238.174 230.400,234.661 230.400 L 230.400 230.400 230.400 235.107 C 230.400 240.589,230.681 240.771,239.147 240.789 C 247.355 240.806,252.235 237.697,256.256 229.888 C 257.399 227.669,272.000 188.392,272.000 187.536 C 272.000 187.351,268.664 187.200,264.587 187.200 L 257.173 187.200 254.032 199.179 C 252.305 205.767,250.693 210.960,250.452 210.719 C 250.210 210.477,248.559 205.177,246.782 198.940 L 243.550 187.600 235.278 187.371 C 228.789 187.191,227.095 187.364,227.416 188.171 M135.470 198.350 C 141.691 200.716,139.740 215.200,133.200 215.200 C 129.157 215.200,127.600 212.822,127.600 206.647 C 127.600 199.685,130.616 196.505,135.470 198.350 M184.292 199.258 C 189.140 203.072,186.738 215.200,181.134 215.200 C 174.533 215.200,172.598 199.820,178.989 198.154 C 181.598 197.473,182.176 197.594,184.292 199.258 " stroke="none" fill="#000000" fill-rule="evenodd"></path></g></svg>
)

const MemoirLogo = () => (
  <svg id="svg"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  width="200%"
  height="400%"
  viewBox="920, 170, 200, 250">
    
  <g id="svgg"><path id="path0" d="M95.200 200.800 L 95.200 225.600 103.600 225.600 L 112.000 225.600 112.000 216.800 L 112.000 208.000 122.400 208.000 L 132.800 208.000 132.800 202.000 L 132.800 196.000 122.400 196.000 L 112.000 196.000 112.000 192.400 L 112.000 188.800 124.000 188.800 L 136.000 188.800 136.000 182.400 L 136.000 176.000 115.600 176.000 L 95.200 176.000 95.200 200.800 M156.376 177.000 C 156.170 177.550,152.082 188.710,147.290 201.800 L 138.578 225.600 147.162 225.600 L 155.747 225.600 156.705 222.400 L 157.664 219.200 166.000 219.200 L 174.336 219.200 175.295 222.400 L 176.253 225.600 184.927 225.600 C 189.697 225.600,193.600 225.361,193.600 225.068 C 193.600 224.657,178.913 184.033,176.366 177.400 C 175.682 175.619,157.032 175.245,156.376 177.000 M199.218 193.800 C 199.240 216.214,200.232 219.253,208.971 223.685 C 219.580 229.065,236.020 227.390,243.424 220.175 C 248.117 215.602,248.800 212.107,248.800 192.655 L 248.800 176.000 240.400 176.000 L 232.000 176.000 232.000 191.962 C 232.000 212.058,230.136 216.040,221.733 213.906 C 216.145 212.487,215.633 210.760,215.341 192.344 L 215.082 176.000 207.141 176.000 L 199.200 176.000 199.218 193.800 M256.191 177.775 C 256.855 178.779,260.467 184.073,264.218 189.539 L 271.037 199.478 262.307 212.539 L 253.577 225.600 263.013 225.600 L 272.450 225.600 276.729 218.371 C 281.575 210.186,280.617 210.044,286.365 219.800 L 289.782 225.600 299.691 225.600 C 305.141 225.600,309.600 225.395,309.600 225.145 C 309.600 224.895,305.820 219.168,301.200 212.419 C 296.580 205.669,292.800 199.933,292.800 199.673 C 292.800 199.412,296.220 194.196,300.400 188.082 C 304.580 181.968,308.000 176.748,308.000 176.483 C 308.000 176.217,303.897 176.000,298.882 176.000 L 289.765 176.000 286.185 182.074 L 282.606 188.147 279.046 182.274 L 275.486 176.400 265.235 176.175 L 254.984 175.951 256.191 177.775 M170.038 205.000 C 170.527 207.200,170.527 207.200,165.970 207.200 C 162.019 207.200,161.464 207.014,161.792 205.800 C 162.001 205.030,163.030 201.425,164.080 197.789 L 165.988 191.178 167.768 196.989 C 168.748 200.185,169.769 203.790,170.038 205.000 " stroke="none" fill="#000000" fill-rule="evenodd"></path></g></svg>
)

const GlobeIcon = ({ fill = 'white' }) => (
  <svg
    width="19"
    height="14"
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.20896 13.9999C7.34271 14.0075 5.54559 13.2942 4.19251 12.0089C3.99106 11.8171 3.90719 11.5325 3.97251 11.2622C4.03782 10.9919 4.24239 10.7769 4.50915 10.6983C4.77591 10.6197 5.06434 10.6894 5.26579 10.8811C6.33096 11.8879 7.74335 12.445 9.20896 12.4366C9.75609 12.4375 10.3006 12.3616 10.8267 12.2111C11.2297 12.1183 11.6349 12.3572 11.7488 12.7548C11.8627 13.1524 11.6455 13.5697 11.2544 13.7043C10.5898 13.898 9.90125 13.9975 9.20896 13.9999ZM16.3176 8.00353C16.3654 7.67126 16.3888 7.33593 16.3876 7.00024C16.3321 3.08455 13.117 -0.0470396 9.20122 0.000534954C6.45785 -0.00568609 3.94655 1.53903 2.71483 3.99037C2.52583 4.37695 2.68601 4.84355 3.07259 5.03254C3.45918 5.22154 3.92578 5.06136 4.11477 4.67478C5.08411 2.75804 7.05334 1.55361 9.20122 1.5638C12.258 1.51614 14.7767 3.95138 14.8321 7.00802C14.8331 7.26825 14.8149 7.5282 14.7777 7.78576C14.7464 7.99001 14.7978 8.19829 14.9203 8.36463C15.0429 8.53097 15.2266 8.6417 15.431 8.67239H15.5632C15.9535 8.67623 16.2863 8.39008 16.3409 8.00353H16.3176ZM18.5887 9.07689C18.6387 8.88411 18.6545 8.68405 18.6354 8.48581C18.5826 8.06792 18.2068 7.76795 17.7876 7.80917C17.3762 7.86566 17.0817 8.23547 17.1188 8.64913C16.9632 9.23244 13.9456 9.92464 8.81246 8.64913C4.92374 7.66918 2.26385 6.11369 1.65721 5.07929C1.5883 4.98755 1.55264 4.8751 1.5561 4.76041C1.65121 4.35218 1.4057 3.94202 1.00097 3.83297C0.596247 3.72393 0.177909 3.95523 0.0550537 4.35598C-0.0711348 4.8728 0.021739 5.41878 0.311709 5.86481C1.25278 7.45919 4.43376 9.14689 8.42359 10.1502C10.2864 10.6343 12.2001 10.8954 14.1245 10.9279C16.4266 10.9824 18.2387 10.4224 18.5965 9.07689H18.5887Z"
      fill={fill}
    />
  </svg>
)

const EyeIcon = ({ fill = 'white' }) => (
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.80781 11.7636C5.89042 11.6782 2.27087 9.65402 0.147117 6.36116C0.0517275 6.2245 0.000394569 6.06195 0 5.89529C0 5.72095 0.0511518 5.55044 0.147117 5.4049C2.209 2.04657 5.86703 0 9.80781 0C13.7486 0 17.4066 2.04657 19.4685 5.4049C19.6536 5.64369 19.6919 5.96513 19.568 6.24072C19.4442 6.5163 19.1784 6.70107 18.8769 6.72115C18.5754 6.74123 18.2874 6.59336 18.1281 6.33664C16.3064 3.48646 13.1893 1.7258 9.80781 1.63706C6.62406 1.71245 3.66329 3.28829 1.82262 5.88711C3.66329 8.48594 6.62406 10.0618 9.80781 10.1372C12.0105 10.1205 14.1393 9.3406 15.8314 7.93041C16.1827 7.6728 16.6743 7.73593 16.949 8.07393C17.2238 8.41193 17.1852 8.90602 16.8613 9.19725C14.8778 10.8429 12.385 11.7498 9.80781 11.7636ZM12.2596 5.7236C12.2596 4.36942 11.1618 3.27165 9.80766 3.27165C9.35627 3.27165 8.99035 3.63757 8.99035 4.08896C8.99035 4.54036 9.35627 4.90628 9.80766 4.90628C10.2591 4.90628 10.625 5.27221 10.625 5.7236C10.625 6.17499 10.2591 6.54092 9.80766 6.54092C9.35627 6.54092 8.99035 6.17499 8.99035 5.7236C8.99035 5.27221 8.62442 4.90628 8.17303 4.90628C7.72164 4.90628 7.35571 5.27221 7.35571 5.7236C7.35571 7.07778 8.45349 8.17555 9.80766 8.17555C11.1618 8.17555 12.2596 7.07778 12.2596 5.7236Z"
      fill={fill}
    />
  </svg>
)

const FigmaIcon = ({ fill = 'white' }) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5172 3.07248C1.5172 2.04865 2.34845 1.2174 3.37228 1.2174H5.22737V4.92756H3.37228C2.34845 4.92756 1.5172 4.09631 1.5172 3.07248ZM3.37228 0C1.6761 0 0.299805 1.3763 0.299805 3.07248C0.299805 4.08075 0.78612 4.97598 1.53686 5.53629C0.78612 6.0966 0.299805 6.99184 0.299805 8.00011C0.299805 9.00831 0.78606 9.9035 1.53672 10.4638C0.78606 11.0241 0.299805 11.9193 0.299805 12.9275C0.299805 14.6237 1.6761 16 3.37228 16C5.06846 16 6.44476 14.6237 6.44476 12.9275V11.0726V10.4639V10.4637V10.4489C6.96038 10.8403 7.60325 11.0726 8.30012 11.0726C9.99631 11.0726 11.3726 9.69629 11.3726 8.00011C11.3726 6.99184 10.8863 6.09661 10.1355 5.5363C10.8863 4.97598 11.3726 4.08075 11.3726 3.07248C11.3726 1.3763 9.99631 0 8.30012 0H6.44476H5.83634H5.83606H5.22764H3.37228ZM3.37228 6.14502C2.34845 6.14502 1.5172 6.97627 1.5172 8.00011C1.5172 9.0177 2.33834 9.84504 3.35357 9.8551L3.37228 9.85504H5.22736V6.14502H3.37228ZM1.5172 12.9275C1.5172 11.9099 2.33834 11.0826 3.35357 11.0725L3.37228 11.0726H5.22736V12.9275C5.22736 13.9514 4.39611 14.7826 3.37228 14.7826C2.34845 14.7826 1.5172 13.9514 1.5172 12.9275ZM6.44504 4.92756H8.30012C9.32396 4.92756 10.1552 4.09631 10.1552 3.07248C10.1552 2.04865 9.32396 1.2174 8.30012 1.2174H6.44504V4.92756ZM6.44504 8.00011C6.44504 6.97627 7.27629 6.14502 8.30012 6.14502C9.32396 6.14502 10.1552 6.97627 10.1552 8.00011C10.1552 9.02394 9.32396 9.85519 8.30012 9.85519C7.27629 9.85519 6.44504 9.02394 6.44504 8.00011Z"
      fill={fill}
    />
  </svg>
)
